export type HashMap<T = any> = {
  [key: string]: T;
};

export type WorkflowStatus = {
  id: number;
  label: string;
  colorCode: string;
};

// TODO: See if this is the right name
export type AdjudicationFlag = {
  value: number;
  label: string;
  children: { label: string; value: string }[];
  extra: Record<string, string>;
  tag: string;
};

export type IntegrationStatus = {
  id: number;
  label: string;
  tag: string;
  colorCode: string;
};

type FilterTags = {
  value: string;
  label: string;
};

export type Kind = {
  id: number;
  fieldFilterTag: string;
  initialData?: {
    objectType: string;
  };
  name: string;
  fieldTagsForFilter: FilterTags[];
  features: string[];
  isSortingFieldEnabled: boolean;
  isRelatedKind: boolean;
  tag: string;
  icon: string;
  availableStatuses: number[];
  description?: string;
  staticGroups?: string[];
  menuIndex: number;
};

export type Alert = {
  id: number;
  fieldId: number;
  stepId: number;
  stepGroupId: number;
  workflowId: number;
  catColorLabel: string;
  alertTag: string;
  value?: number | string; // applicable for LCData alerts
};

export type SelectOption = {
  label: string;
  value: string | number;
};

export type ProcessTypeFilterOption = {
  id: number;
  name: string;
};

export type GroupedCheckboxOption = {
  label: string;
  value: string;
  parent: string;
};

export type CascaderOption = {
  label: string;
  value: string;
  disabled?: boolean;
  children?: CascaderOption[];
};
export type UserListOption = {
  id: number;
  email: string;
  first_name: string | undefined;
  last_name: string | undefined;
};

export type WorkflowDynamicAPIResultType<T> = {
  results: T[];
  count: number;
  previous: number | null;
  next: number | null;
};
export type FieldData = {
  name: number;
  key: number;
  fieldKey: number;
};
export type PaginatedSelectFieldApiUrlResponse = {
  count: number;
  next: string | null;
  total: number;
  results: {
    id: number;
    label: string;
    value: string;
  }[];
};

export type NamePath = string | number | (string | number)[];

export type TooltipPlacement =
  | "top"
  | "left"
  | "right"
  | "bottom"
  | "topLeft"
  | "topRight"
  | "bottomLeft"
  | "bottomRight"
  | "leftTop"
  | "leftBottom"
  | "rightTop"
  | "rightBottom";

export type Maybe<T> = T | null;
export type Optional<T> = T | undefined;
export type MaybeOptional<T> = Optional<Maybe<T>>;

export type DeepReadonly<T> = Readonly<{
  [K in keyof T]: T[K] extends number | string | symbol // Is it a primitive? Then make it readonly
    ? Readonly<T[K]>
    : // Is it an array of items? Then make the array readonly and the item as well
      T[K] extends (infer A)[]
      ? Readonly<DeepReadonly<A>[]>
      : // It is some other object, make it readonly as well
        DeepReadonly<T[K]>;
}>;

export type DeepMutable<T> = {
  -readonly [K in keyof T]: T[K] extends number | string | symbol // Is it a primitive? Then keep it mutable
    ? T[K]
    : // Is it an array of items? Then make the array and its items mutable
      T[K] extends (infer A)[]
      ? DeepMutable<A>[]
      : // It is some other object, make it mutable as well
        DeepMutable<T[K]>;
};

export type ReactRouterLocation = Pick<
  typeof window.location,
  "pathname" | "search" | "hash"
>;

export enum DateRangeValues {
  START_DATE = "start_date",
  END_DATE = "end_date",
  IS_DATE_TIME = "is_date_time"
}

export type DateRangeValuesType = {
  [DateRangeValues.START_DATE]: string | null;
  [DateRangeValues.END_DATE]: string | null;
  [DateRangeValues.IS_DATE_TIME]?: boolean;
};
